// Need to use the React-specific entry point to import createApi
import {
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import {
  getStorage,
} from '../utils/functions/localstorage';
// Define a service using a base URL and expected endpoints
const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL}/payment-transaction`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');

    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const paymentTransactionApi = createApi({
  reducerPath: 'paymentTransactionApi',
  baseQuery,
  endpoints: (builder) => ({
    waitingForPayment: builder.query({
      query: (q) => `/?customerCode=${q.customerCode}&sorgcode=${q.sorgcode}&page=${q.page}&size=${q.size}&status=${q.status}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useWaitingForPaymentQuery,
} = paymentTransactionApi;
